import * as constants from './actions';

import { getInitiatedTime, getTimeFrom } from '../../utils/actionTiming';

const initialState = {
    actionInitiated: false,
    actionCancelled: false,
    isAddressSubmitting: false,
    showAddressPopup: false,
    googleMapIsLoaded: false
};

export default function findPollingStation(state = initialState, { type, payload }) {
    switch (type) {
        case constants.FIND_POLLING_STATION_INITIATED:
            return {
                ...state,
                ...getInitiatedTime(payload, state),
                actionInitiated: true
            };
        case constants.FIND_POLLING_STATION_SUBMITTING:
            return {
                ...state,
                isAddressSubmitting: payload.isAddressSubmitting
            };
        case constants.FIND_POLLING_STATION_COMPLETED:
            return {
                ...state,
                completeFindPollingStation: payload,
                actionCompletionTime: getTimeFrom(
                    Object.values(getInitiatedTime(payload, state))[0]
                )
            };
        case constants.FIND_POLLING_STATION_CANCELED:
            return {
                ...state,
                actionCancelled: true,
                actionPreviouslyCancelled: state.actionCancelled ? true : false,
                actionCancelledTime: getTimeFrom(
                    Object.values(getInitiatedTime(payload, state))[0]
                )
            };
        case constants.FIND_POLLING_STATION_ERROR:
            return {
                ...state,
                findPollingStationError: payload
            };
        case constants.SET_SUCCESS_INFO:
            return {
                ...state,
                actionIdentifier:
                    state.actionIdentifier !== undefined
                        ? [...state.actionIdentifier, payload.actionIdentifier]
                        : [payload.actionIdentifier]
            };
        case constants.SHOW_ADDRESS_LOOKUP_POPUP:
            return {
                ...state,
                showAddressPopup: payload
            };
        case constants.FIND_POLLING_STATION_MAP_LOADED:
            return {
                ...state,
                googleMapIsLoaded: payload
            };
        default:
            return state;
    }
}
